// extracted by mini-css-extract-plugin
export default {"topWinner":"LineItem__topWinner--2Xs","justWon":"LineItem__justWon--1fW","winAmount":"LineItem__winAmount--3CM","separator":"LineItem__separator--75T"};